<template>
  <div class="header-menu">
    <Dropdown position="right" class="header-menu__profile" @toggle="handleToggleAvatar">
      <div class="header-menu__burger-wrapper">
        <IconBurger />
      </div>
      <DropdownMenu slot="menu">
        <HeaderMenuItem menu="SignOut" @click.native="handleSignOut">Sign Out</HeaderMenuItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Dropdown, { DropdownMenu } from '@/components/common/Dropdown';
import HeaderMenuItem from './HeaderMenuItem';

export default {
  name: 'HeaderMenuOutsider',
  components: {
    Dropdown,
    DropdownMenu,
    HeaderMenuItem,
    IconBurger: () => import('@/components/Icon/Burger.vue'),
  },
  methods: {
    ...mapActions(['signOut']),
    async handleSignOut() {
      try {
        await this.signOut();
      } catch (e) {
        this.$notice.error(e);
        this.$sentryUtils.error(e);
      }
    },
    handleToggleAvatar(show = false) {
      this.$analytics.logEvent(`global__header-nav__avatar__click`, { show });
    },
  },
};
</script>

<style scoped lang="scss">
.header-menu {
  display: flex;
  align-items: center;

  &__profile {
    margin-left: 18px;
    cursor: pointer;
  }

  &__burger-wrapper {
    display: flex;
    align-items: center;
    color: var(--theme-color-text);
    cursor: pointer;
  }
}
</style>
